import { apiRequest } from "./apiClient";

export const authService = {
  async register({ email, password, name }) {
    return apiRequest("/auth/register", {
      method: "POST",
      body: JSON.stringify({ email, password, name }),
    });
  },

  async login({ email, password }) {
    return apiRequest("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
  },

  async validateToken(token) {
    try {
      const data = await apiRequest("/auth/validate-token", {
        method: "POST",
        body: JSON.stringify({ token }),
      });
      return !!data?.valid;
    } catch (error) {
      return false;
    }
  },
};
